/* Wishlist — theme clone of XB Wishlist. List kept in the browser; for a logged-in customer it is synced to the
   customer metafields through the app proxy (C.proxy, e.g. /apps/wl). Buttons are rendered by Liquid;
   this file stores the list, toggles state, shows notifications and fills the wishlist page.
   Entry: {h: handle, t: ms, v?: variant id, l?: list id ("" default, "o:<occasion>", "u:<own>")}; the same product /
   variant may be in several lists. Multiple lists (C.ml) are for logged-in customers only. */
(function () {
  var cfgEl = document.getElementById('wl-config');
  if (!cfgEl) return;
  var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  C.t = C.t || {};
  var KEY = 'wl:v1', LKEY = 'wl:lists', root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var page = null, grid = null, more = null, queue = [], shared = null, tab = '*', ALL = '*';
  var CUST = C.cust ? String(C.cust) : null, PROXY = C.proxy ? root.replace(/\/$/, '') + C.proxy : null;
  var ML = C.ml && C.ml.on ? C.ml : null, MT = (ML && ML.t) || {};
  function multi() { return !!(ML && CUST && PROXY); }

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function arr(k) { try { var a = JSON.parse(ls(k) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function load() { return arr(KEY).filter(function (x) { return x && x.h; }); }
  function save(a) { ls(KEY, JSON.stringify(a)); }
  function lists() { return arr(LKEY).filter(function (x) { return x && x.id && x.n; }); }
  function saveLists(a) { ls(LKEY, JSON.stringify(a)); }
  function key(x) { return x.h + '|' + (x.v || '') + '|' + (x.l || ''); }
  function handles() { var s = {}, o = []; load().forEach(function (x) { if (!s[x.h]) { s[x.h] = 1; o.push(x.h); } }); return o; }
  function addEntry(h, v, l, sl) { var a = load(), it = { h: h, t: Date.now() }; if (v) it.v = v; if (l) it.l = l; if (sl) it.s = 1; if (a.some(function (x) { return key(x) === key(it); })) return false; a.unshift(it); save(a); push(); return true; }
  function dropKey(k) { save(load().filter(function (x) { return key(x) !== k; })); push(); }
  function dropHandle(h) { save(load().filter(function (x) { return x.h !== h; })); push(); }
  function update(k, fn) { var a = load(), out = [], seen = {}; a.forEach(function (x) { if (key(x) === k) fn(x); var kk = key(x); if (!seen[kk]) { seen[kk] = 1; out.push(x); } }); save(out); push(); }
  /* variant currently selected in the product form (product page only; card hearts save no size) */
  function pageVariant() { var f = document.querySelector('form[action*="/cart/add"] [name="id"]'); return f && /^\d+$/.test(f.value) ? f.value : null; }
  function listName(id) {
    if (!id) return (ML && ML.def) || '';
    if (id.indexOf('o:') === 0) { var o = (ML && ML.occ || []).filter(function (x) { return x.id === id; })[0]; return o ? o.n : id.slice(2); }
    var u = lists().filter(function (x) { return x.id === id; })[0]; return u ? u.n : '';
  }
  function allLists() {
    var o = [{ id: '', n: listName('') }];
    if (ML) o = o.concat(ML.occ || []);
    return o.concat(lists());
  }

  /* account sync: server list is the source of truth for a logged-in customer; a guest list is merged on login;
     on logout the browser copy is cleared; an unconfirmed change (wl:dirty) is re-sent on the next page load */
  function push() {
    if (!CUST || !PROXY) return;
    ls('wl:dirty', '1');
    fetch(PROXY, { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: load(), lists: lists() }) })
      .then(function (r) { if (r.ok) ls('wl:dirty', null); }).catch(function () {});
  }
  function account() {
    var owner = ls('wl:owner');
    if (!CUST) { if (owner) { save([]); saveLists([]); ls('wl:owner', null); ls('wl:dirty', null); } return; }
    if (!PROXY) return;
    var srv = (Array.isArray(C.acct) ? C.acct : []).filter(function (x) { return x && x.h; });
    var srvL = (ML && Array.isArray(ML.lists) ? ML.lists : []).filter(function (x) { return x && x.id && x.n; });
    if (owner === CUST) {
      if (ls('wl:dirty')) { push(); return; }
      save(srv); saveLists(srvL); return;
    }
    var seen = {}, merged = [];
    srv.concat(owner ? [] : load()).forEach(function (x) { var k = key(x); if (!seen[k]) { seen[k] = 1; merged.push(x); } });
    merged.sort(function (a, b) { return (b.t || 0) - (a.t || 0); });
    save(merged); saveLists(srvL); ls('wl:owner', CUST); ls('wl:dirty', null);
    if (merged.length !== srv.length) push();
  }
  function enc(s) { return encodeURIComponent(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function sync() {
    var hs = handles();
    document.querySelectorAll('[data-wl]').forEach(function (b) {
      var on = hs.indexOf(b.getAttribute('data-wl')) > -1, l = b.getAttribute(on ? 'data-on' : 'data-off');
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (l) { b.setAttribute('aria-label', l); var t = b.querySelector('[data-wl-text]'); if (t) t.textContent = l; }
    });
    document.querySelectorAll('[data-wl-count]').forEach(function (c) { c.textContent = hs.length; c.hidden = !hs.length; });
  }

  var box = null;
  function toast(msg, err) {
    if (!C.toast || !msg) return;
    if (!box) { box = document.createElement('div'); box.className = 'wl-toasts wl-toasts--' + C.toast; document.body.appendChild(box); }
    var el = document.createElement('div');
    el.className = 'wl-toast wl-tf-' + (C.toastAnim || 'fade') + (err ? ' wl-toast--err' : '');
    el.setAttribute('role', 'status');
    el.innerHTML = '<span></span><button type="button" aria-label="' + esc(C.t.zatvori) + '">&times;</button>';
    el.firstChild.textContent = msg;
    el.lastChild.addEventListener('click', function () { el.remove(); });
    box.appendChild(el);
    setTimeout(function () { el.classList.add('is-out'); setTimeout(function () { el.remove(); }, 300); }, C.toastMs || 3000);
  }
  function anim(b) { b.classList.remove('wl-anim'); void b.offsetWidth; b.classList.add('wl-anim'); setTimeout(function () { b.classList.remove('wl-anim'); }, 800); }

  /* list picker (logged-in, multiple lists): checkboxes per list for this product + size */
  var dlg = null, pick = null;
  function newId() { return 'u:' + Math.random().toString(36).slice(2, 10); }
  function canNew() { return ML && ML.own && lists().length < (ML.max || 10); }
  function openPicker(h, v, btn) {
    pick = { h: h, v: v, btn: btn };
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'wl-pick color-scheme';
      dlg.innerHTML = '<div class="wl-pick__box"><p class="wl-pick__title"></p><div class="wl-pick__lists"></div>' +
        '<div class="wl-pick__new"><input class="input" maxlength="40"><button type="button" class="button button--sm button--outline" data-wl-pick-new></button></div>' +
        '<button type="button" class="button button--sm w-full" data-wl-pick-done></button></div>';
      dlg.querySelector('.wl-pick__title').textContent = MT.dodaj || '';
      dlg.querySelector('.wl-pick__new input').placeholder = MT.naziv || '';
      dlg.querySelector('[data-wl-pick-new]').textContent = MT.napravi || '+';
      dlg.querySelector('[data-wl-pick-done]').textContent = MT.gotovo || 'OK';
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-wl-pick-done]')) { dlg.close(); return; }
        if (e.target.closest('[data-wl-pick-new]')) {
          var inp = dlg.querySelector('.wl-pick__new input'), n = inp.value.trim().slice(0, 40);
          if (!n || !canNew()) return;
          var id = newId(), a = lists(); a.push({ id: id, n: n }); saveLists(a); inp.value = '';
          if (addEntry(pick.h, pick.v, id)) toast(C.t.dodato);
          renderPicker(); sync();
        }
      });
      dlg.addEventListener('change', function (e) {
        var cb = e.target.closest('input[type="checkbox"][data-l]');
        if (!cb) return;
        var l = cb.getAttribute('data-l');
        if (cb.checked) { if (addEntry(pick.h, pick.v, l)) toast(C.t.dodato); }
        else { dropKey(key({ h: pick.h, v: pick.v, l: l })); toast(C.t.uklonjeno); }
        sync(); if (pick.btn) anim(pick.btn);
      });
      dlg.addEventListener('close', function () { if (page && !shared) fill(); });
      document.body.appendChild(dlg);
    }
    renderPicker();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function renderPicker() {
    var have = {}; load().forEach(function (x) { if (x.h === pick.h && (x.v || null) === (pick.v || null)) have[x.l || ''] = 1; });
    var row = function (x) { return '<label class="wl-pick__row"><input type="checkbox" data-l="' + esc(x.id) + '"' + (have[x.id] ? ' checked' : '') + '><span>' + esc(x.n) + '</span></label>'; };
    var occ = (ML.occ || []), own = lists();
    var h = row({ id: '', n: listName('') });
    if (occ.length) h += '<p class="wl-pick__group">' + esc(MT.prilike) + '</p>' + occ.map(row).join('');
    if (ML.own && own.length) h += '<p class="wl-pick__group">' + esc(MT.moje) + '</p>' + own.map(row).join('');
    dlg.querySelector('.wl-pick__lists').innerHTML = h;
    dlg.querySelector('.wl-pick__new').hidden = !canNew();
  }

  function itemKey(el) { return el.getAttribute('data-wl-key') || ''; }
  function isAllKey(k) { return k.slice(-2) === '|' + ALL; }
  function dropAny(k) { if (!isAllKey(k)) { dropKey(k); return; } var p = k.split('|'); save(load().filter(function (x) { return !(x.h === p[0] && (x.v || '') === p[1]); })); push(); }
  function removeEl(el) { el.remove(); if (!grid.querySelector('[data-wl-item]') && !queue.length) empty(true); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wl]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-wl'), v = b.classList.contains('wl-heart') ? null : pageVariant();
      var on = handles().indexOf(h) < 0;
      if (on) addEntry(h, v, ''); else dropHandle(h);
      sync(); anim(b); toast(on ? C.t.dodato : C.t.uklonjeno);
      if (!on && page && !shared) { page.querySelectorAll('[data-wl-item]').forEach(function (it) { if (it.getAttribute('data-wl-item') === h) removeEl(it); }); }
      return;
    }
    var r = e.target.closest('[data-wl-remove]');
    if (r) { e.preventDefault(); var el = r.closest('[data-wl-item]'); if (el && !shared) { dropAny(itemKey(el)); sync(); toast(C.t.uklonjeno); removeEl(el); renderTabs(); } return; }
    var s = e.target.closest('[data-wl-share]');
    if (s) { e.preventDefault(); share(s.getAttribute('data-wl-share')); return; }
    var w = e.target.closest('[data-wl-view]');
    if (w) { e.preventDefault(); setView(w.getAttribute('data-wl-view'), true); return; }
    var pk = e.target.closest('[data-wl-pick]');
    if (pk) { e.preventDefault(); var ie = pk.closest('[data-wl-item]'), kp = itemKey(ie).split('|'); openPicker(kp[0], kp[1] || null, null); return; }
    var t = e.target.closest('[data-wl-tab]');
    if (t) { e.preventDefault(); tab = t.getAttribute('data-wl-tab'); ls('wl:tab', tab); fill(); return; }
    if (e.target.closest('[data-wl-newlist]')) {
      e.preventDefault(); if (!canNew()) return;
      var n = (window.prompt(MT.naziv || '', '') || '').trim().slice(0, 40); if (!n) return;
      var a = lists(), id = newId(); a.push({ id: id, n: n }); saveLists(a); push(); tab = id; ls('wl:tab', tab); fill(); return;
    }
    if (e.target.closest('[data-wl-rename]')) {
      e.preventDefault();
      var nn = (window.prompt(MT.naziv || '', listName(tab)) || '').trim().slice(0, 40); if (!nn) return;
      saveLists(lists().map(function (x) { if (x.id === tab) x.n = nn; return x; })); push(); renderTabs(); return;
    }
    if (e.target.closest('[data-wl-delete]')) {
      e.preventDefault();
      if (!window.confirm((MT.obrisi_potvrda || '').replace('{{name}}', listName(tab)))) return;
      var del = tab; saveLists(lists().filter(function (x) { return x.id !== del; }));
      save(load().filter(function (x) { return (x.l || '') !== del; })); push(); sync(); tab = ALL; ls('wl:tab', ALL); fill(); return;
    }
    var lt = e.target.closest('[data-wl-later]');
    if (lt) { e.preventDefault(); later(lt); return; }
    if (e.target.closest('[data-wl-addall]')) { e.preventDefault(); addAll(e.target.closest('[data-wl-addall]')); return; }
    if (e.target.closest('[data-wl-more]')) { e.preventDefault(); next(); }
  }, true);

  function cartRefresh() {
    return fetch(root + 'cart.js').then(function (x) { return x.json(); }).then(function (cart) {
      document.querySelectorAll('cart-count').forEach(function (c) { c.textContent = cart.item_count; });
      document.querySelectorAll('cart-dot').forEach(function (d) { d.classList.toggle('is-visible', cart.item_count > 0); });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return cart;
    });
  }
  /* cart line -> wishlist (default list, with its variant), then removed from the cart */
  function later(b) {
    b.disabled = true;
    addEntry(b.getAttribute('data-wl-later'), b.getAttribute('data-wl-v') || null, '', 1); sync();
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-wl-line'), quantity: 0 }) })
      .then(function (r) { if (!r.ok) throw new Error('change'); return cartRefresh(); })
      .then(function () { toast(C.t.kasnije); if (/\/cart\/?$/.test(location.pathname)) location.reload(); })
      .catch(function () { b.disabled = false; toast(C.t.greska, true); });
  }
  /* every available item of the current list (all pages loaded first), each with its selected size */
  function loadAll() { return queue.length ? next().then(loadAll) : Promise.resolve(); }
  function addAll(b) {
    if (!page) return;
    b.disabled = true;
    loadAll().then(function () {
      var items = [];
      grid.querySelectorAll('[data-wl-item] [data-wl-form] [name="id"]').forEach(function (f) { if (/^\d+$/.test(f.value)) items.push({ id: +f.value, quantity: 1 }); });
      if (!items.length) throw new Error('empty');
      return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return cartRefresh(); })
        .then(function () { toast((C.t.sve || '').replace('{{count}}', items.length)); if (C.afterCart === 'cart') location.href = root + 'cart'; });
    }).catch(function () { toast(C.t.greska, true); }).then(function () { b.disabled = false; });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-wl-form]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button'), id = f.querySelector('[name="id"]').value, item = f.closest('[data-wl-item]');
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (res) { if (!res.ok) throw new Error('add'); return fetch(root + 'cart.js').then(function (x) { return x.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('cart-count').forEach(function (c) { c.textContent = cart.item_count; });
        document.querySelectorAll('cart-dot').forEach(function (d) { d.classList.toggle('is-visible', cart.item_count > 0); });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        toast(C.t.korpa);
        if (C.afterCart === 'cart') { location.href = root + 'cart'; return; }
        if (C.afterCart === 'remove' && !shared && item) { dropAny(itemKey(item)); sync(); removeEl(item); renderTabs(); }
      })
      .catch(function () { toast(C.t.greska, true); })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);

  function shareUrl() {
    var hs = shared || (multi() && tab !== ALL ? handlesIn(tab) : handles());
    var u = new URL(C.pageUrl || location.pathname, location.origin); u.searchParams.set('wl', hs.join(',')); return u.toString();
  }
  function share(k) {
    var u = shareUrl(), m = { Facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + enc(u), X: 'https://twitter.com/intent/tweet?url=' + enc(u), WhatsApp: 'https://wa.me/?text=' + enc(u) };
    if (k === 'Link') { (navigator.clipboard ? navigator.clipboard.writeText(u) : Promise.reject()).then(function () { toast(C.t.link); }, function () { window.prompt('', u); }); return; }
    if (k === 'Email') { location.href = 'mailto:?subject=' + enc(document.title) + '&body=' + enc(u); return; }
    if (m[k]) window.open(m[k], '_blank', 'noopener,width=640,height=560');
  }

  function setView(v, remember) {
    if (!page) return;
    page.classList.toggle('wl-view-list', v === 'list'); page.classList.toggle('wl-view-grid', v !== 'list');
    page.querySelectorAll('[data-wl-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-wl-view') === v ? 'true' : 'false'); });
    if (remember) ls('wl:view', v);
  }
  function empty(on) { page.classList.toggle('is-empty', !!on); var em = page.querySelector('[data-wl-empty]'); if (em) em.hidden = !on; }
  var cache = {};
  function fetchItem(h) {
    if (!cache[h]) cache[h] = fetch(root + 'products/' + enc(h) + '?view=wl-item').then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { return t && t.indexOf('data-wl-item') > -1 ? t : null; }).catch(function () { return null; });
    return cache[h];
  }
  function handlesIn(l) { var s = {}, o = []; load().forEach(function (x) { if ((x.l || '') === l && !s[x.h]) { s[x.h] = 1; o.push(x.h); } }); return o; }

  /* tabs: default list, occasions that have items, own lists (also empty) + new / rename / delete */
  var tabsEl = null;
  function renderTabs() {
    if (!tabsEl) return;
    var cnt = {}; load().forEach(function (x) { var l = x.l || ''; cnt[l] = (cnt[l] || 0) + 1; });
    var shown = allLists().filter(function (x) { return x.id === '' || x.id.indexOf('u:') === 0 || cnt[x.id]; });
    if (tab !== ALL && !shown.some(function (x) { return x.id === tab; })) tab = ALL;
    var all = {}; load().forEach(function (x) { all[x.h + '|' + (x.v || '')] = 1; });
    shown = [{ id: ALL, n: ML.all || '' }].concat(shown); cnt[ALL] = Object.keys(all).length;
    var h = '<div class="wl-tabs__list" role="tablist">' + shown.map(function (x) {
      return '<button type="button" role="tab" class="wl-tab" data-wl-tab="' + esc(x.id) + '" aria-selected="' + (x.id === tab) + '">' + esc(x.n) + ' <span>' + (cnt[x.id] || 0) + '</span></button>';
    }).join('') + (canNew() ? '<button type="button" class="wl-tab wl-tab--new" data-wl-newlist>+ ' + esc(MT.nova) + '</button>' : '') + '</div>';
    if (tab.indexOf('u:') === 0) h += '<div class="wl-tabs__actions"><button type="button" class="link" data-wl-rename>' + esc(MT.preimenuj) + '</button><button type="button" class="link" data-wl-delete>' + esc(MT.obrisi) + '</button></div>';
    tabsEl.innerHTML = h;
  }
  function listsBox(entry) {
    var names = load().filter(function (x) { return x.h === entry.h && (x.v || '') === (entry.v || ''); }).map(function (x) { return listName(x.l || ''); });
    return '<div class="wl-item__lists"><button type="button" class="button button--sm button--outline" data-wl-pick>' + esc(MT.dodaj) + '</button>' +
      (names.length ? '<p class="wl-item__on">' + esc(names.join(', ')) + '</p>' : '') + '</div>';
  }
  /* key, saved size, sold-out note and "move to" for one rendered item */
  function decorate(el, entry) {
    el.setAttribute('data-wl-key', multi() && tab === ALL ? entry.h + '|' + (entry.v || '') + '|' + ALL : key(entry));
    if (shared) return;
    if (multi()) { var info = el.querySelector('.wl-item__info'); if (info) info.insertAdjacentHTML('beforeend', listsBox(entry)); }
    if (!entry.v) return;
    var sel = el.querySelector('select[name="id"]'), note = el.querySelector('[data-wl-vnote]'), form = el.querySelector('[data-wl-form]');
    if (sel && sel.querySelector('option[value="' + entry.v + '"]')) { sel.value = entry.v; return; }
    var map = {}; try { map = JSON.parse('{' + ((form && form.getAttribute('data-wl-vt')) || '') + '}'); } catch (e) {}
    if (note && map[entry.v]) { note.textContent = map[entry.v] + ' — ' + note.getAttribute('data-out'); note.hidden = false; }
  }
  document.addEventListener('change', function (e) {
    if (shared) return;
    var sel = e.target.closest('[data-wl-item] select[name="id"]');
    if (sel) {
      var item = sel.closest('[data-wl-item]'), note = item.querySelector('[data-wl-vnote]'), k = itemKey(item);
      if (isAllKey(k)) { var q = k.split('|'), aa = load(), seen = {}, out = []; aa.forEach(function (x) { if (x.h === q[0] && (x.v || '') === q[1]) x.v = sel.value; var kk = key(x); if (!seen[kk]) { seen[kk] = 1; out.push(x); } }); save(out); push(); }
      else update(k, function (x) { x.v = sel.value; });
      var p = k.split('|'); item.setAttribute('data-wl-key', p[0] + '|' + sel.value + '|' + p[2]);
      if (note) note.hidden = true;
      return;
    }
  });

  function next() {
    var per = +(page.getAttribute('data-per') || 8), batch = queue.splice(0, per);
    if (more) more.hidden = true;
    return Promise.all(batch.map(function (x) { return fetchItem(x.h); })).then(function (list) {
      list.forEach(function (html, i) {
        if (html) { var d = document.createElement('div'); d.innerHTML = html; var el = d.firstElementChild; grid.appendChild(el); decorate(el, batch[i]); }
        else if (!shared) dropHandle(batch[i].h);
      });
      sync();
      if (more) more.hidden = !queue.length;
      if (!grid.querySelector('[data-wl-item]') && !queue.length) empty(true);
    });
  }
  function fill() {
    grid.innerHTML = '';
    var seenAll = {};
    queue = shared ? shared.map(function (h) { return { h: h }; }) : load().filter(function (x) {
      if (!multi()) return true;
      if (tab !== ALL) return (x.l || '') === tab;
      var k = x.h + '|' + (x.v || ''); if (seenAll[k]) return false; seenAll[k] = 1; return true;
    });
    if (multi()) renderTabs();
    if (!queue.length) { empty(true); if (more) more.hidden = true; return; }
    empty(false); next();
  }
  function initPage() {
    page = document.querySelector('[data-wl-page]');
    if (!page) return;
    grid = page.querySelector('[data-wl-grid]'); more = page.querySelector('[data-wl-more]');
    var q = new URLSearchParams(location.search).get('wl');
    if (q) { shared = q.split(',').filter(Boolean).slice(0, 100); page.classList.add('is-shared'); }
    var v = page.getAttribute('data-view') || 'grid';
    if (page.hasAttribute('data-switch')) v = ls('wl:view') || v;
    setView(v, false);
    if (!shared && multi()) { tab = ls('wl:tab') || ALL; tabsEl = document.createElement('div'); tabsEl.className = 'wl-tabs'; grid.parentNode.insertBefore(tabsEl, grid); }
    if (!shared && ML && !CUST && ML.login) {
      var lp = document.createElement('p'); lp.className = 'wl-login';
      lp.innerHTML = esc(MT.prijava) + ' <a class="link" href="' + esc(ML.login) + '">' + esc(MT.prijava_dugme) + '</a>';
      grid.parentNode.insertBefore(lp, grid);
    }
    fill();
  }

  function start() {
    account(); sync(); initPage();
    window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
    var pend = null;
    new MutationObserver(function (ms) {
      if (pend) return;
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { pend = setTimeout(function () { pend = null; sync(); }, 150); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
